'use strict';

module.exports = require('./Progress');


// WEBPACK FOOTER //
// ./_rc-progress-1.0.4/lib/index.js